import { TextAndImageSelectionField } from 'components';
import FaceToFace from '@app/illu/Large/FaceToFace.svg';
import PhoneCall from '@app/illu/Large/PhoneCall.svg';
import VideoCall from '@app/illu/Large/VideoCall.svg';
import { QuoteInformation, SessionFormat } from '@app/api';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase * 2 + 'px',

    [theme.media.desktop]: {
      flexDirection: 'row',
      flexWrap: 'no-wrap',
    },
  },
}));

export const StudyFormatModeratedSection = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  const { values } = useFormikContext<Partial<QuoteInformation>>();
  const { groupMeeting } = values;

  return (
    <div className={classes.container}>
      <TextAndImageSelectionField
        illustration={VideoCall}
        title={t('studySetup.generalSetup.format.videoCall')}
        name="format"
        value={SessionFormat.VIDEO_CALL}
        isCompact
        trackingName="Format"
      />
      {!groupMeeting && (
        <TextAndImageSelectionField
          illustration={PhoneCall}
          title={t('studySetup.generalSetup.format.phoneCall')}
          name="format"
          value={SessionFormat.PHONE_CALL}
          isCompact
          trackingName="Format"
        />
      )}
      <TextAndImageSelectionField
        illustration={FaceToFace}
        title={t('studySetup.generalSetup.format.inPerson')}
        name="format"
        value={SessionFormat.PHYSICAL_MEETING}
        isCompact
        trackingName="Format"
      />
    </div>
  );
};
